import { ACTIVE_NETWORK } from './networks';

// ==========================================================================
// FILL IN YOUR DEPLOYED CONTRACT ADDRESSES BELOW
// ==========================================================================

const ADDRESSES = {
  mainnet: {
    cryptoPay: '0xE31C467eB623242958354Fc0a8C014092500931E',
    cryptoPayViews: '0x99b3685608ca2A9e0E5D60Ce9A3239791Cb3caFA',
    usdt: '0x55d398326f99059fF775485246999027B3197955', // BSC USDT
    token2: '0x55d398326f99059fF775485246999027B3197955'
  },
  testnet: {
    cryptoPay: '0x538Bfc2384CE3a20AA5eFDf917D42bC50F8697Bc',
    cryptoPayViews: '0x627cB4936D39AE4d2B5CA08E9C48C84C134a8c20',
    usdt: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC',
    token2: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC'
  }
};

export const CONTRACTS = ADDRESSES[ACTIVE_NETWORK];
